export namespace TunnelSanteActionModels {
  /** Documents  */
  export enum PolicyActionType {
    CreationDuCompteClient = 1,
    PaiementDuComplement = 2,
    ModificationDevis = 3,
    DepotDeDocument = 4,
    MiseEnGarantieProvisoire = 5,
    ActivationDeLaPolice = 6,
    PaiementQuittanceParPrelevement = 7,
    PaiementQuittanceParCB = 8,
    Resiliation = 9,
    MiseEnRejet = 10,
    ChangementQuantieme = 11,
    MiseEnDemeure = 12,
    Avenant = 13,
    Suspension = 14,
    RemiseEnActif = 15,
    RemiseEnVigueur = 16,
    ResiliationForNpp = 17,
    Caducite = 18,
    Nullite = 19,
    FinGarantieProvisoire = 20,
    SuppressionFraisDeRejet = 21,
    PropositionRenouvellement = 22,
    RenouvellementRejeteParAssureur = 23,
    RenouvellementDeLaPolice = 24,
    RemboursementClientVirement = 25,
    QuittanceDeRemboursementAccepte = 26,
    QuittanceDeRemboursementAnnule = 27,
    RemboursementClientChèque = 28,
    RemboursementClientCB = 29,
    CreationRemboursementSinistreClientChèque = 30,
    CreationRemboursementSinistreClientVirement = 31,
    MiseEnRejetDoublon = 32,
    PaiementQuittanceParPrelevementDoublon = 33,
    CreationDuCompteClientDoublon = 34,
    CreationRemboursementRegularisation = 35,
    CreationPaiementRegularisation = 36,
    AnnulationRejetSante = 37,
    MiseAJourContractStartDate = 38,
    ReversementRetentionPoliceSanté = 39,
    VersementComptantPoliceSanté = 40,
    RepriseVersementComptantPoliceSanté = 41,
    VersementFraisDossierCourtierPoliceSanté = 42,
    VersementLineairePoliceSante = 43,
    FauxRejet = 44,
    PaiementQuittanceParPrelevementFauxRejet = 45,
    PaiementComplementAvenant = 46,
    PropositionRenouvellementAvecAvenant = 47,
    CreationRemboursementMisc = 48,
    FauxPrelevement = 49,
    RemboursementSinistreClientChèque = 50,
    RemboursementSmallTox = 51,
  }
}
